// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ao-z","badgeLink":"Bo-z","category":"Co-z"};